export default "https://cdn-static.gokick.com/assets/e732fce3df71ad981aa0ee65436659b369042414/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";